var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"app"}},[(!_vm.authenticated)?_c('login',{on:{"login":_vm.login}}):_c('dashboard',{attrs:{"token":_vm.token}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }